module.exports = __webpack_public_path__ + "assets/img/tx264_4.210ddbfc.jpg";